class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.bindHoverOpen();
  }

  // Opt-in (settings.open_menu_on_hover no header): sem isso, um item com submenu só abre
  // ao clicar, e quem só passa o mouse pode nem perceber que há subcategorias. Reaproveita
  // o mesmo <details> do clique — abrir/fechar via `.open` dispara o `toggle` nativo, que já
  // aciona onToggle() (animação e --header-bottom-position-desktop) sem duplicar lógica.
  // Só em mouse/trackpad (hover:hover e pointer:fine); toque continua só por clique.
  bindHoverOpen() {
    if (!this.closest('.header__inline-menu--hover-open')) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    // O painel do mega menu é ancorado no fim do header, não no item: entre os dois há uma
    // faixa vazia. Fechar já no mouseleave impedia alcançar as subcategorias, então o
    // fechamento espera um pouco e é cancelado se o cursor volta ao item ou entra no painel.
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.hoverCloseTimer);
      document.querySelectorAll('header-menu').forEach((menu) => {
        if (menu !== this && menu.mainDetailsToggle.open) menu.mainDetailsToggle.open = false;
      });
      this.mainDetailsToggle.open = true;
    });
    this.addEventListener('mouseleave', () => {
      clearTimeout(this.hoverCloseTimer);
      this.hoverCloseTimer = setTimeout(() => {
        this.mainDetailsToggle.open = false;
      }, 250);
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
